import { Directive } from '@angular/core';

@Directive({ selector: '[xngBreadcrumbItem]' })
export class BreadcrumbItemDirective {
  constructor() {}
}
